import { ReactNode } from "react";

export enum AdjustmentType {
    means,
    permissions
}

export interface Adjustment {
    id: string,
    oneId?: string,
    name?: string,
    isActive: boolean;
    sioeoImport: boolean;
}

export interface Adjustments {
    adjustmentTypes: Adjustment[];
    adjustmentPermissions: Adjustment[];
}

export interface AdjustmentTableItem extends Adjustment {
    [key: string]: Element | ReactNode | Date;
    id: string;
    isActiveElement: JSX.Element;
    sioeoImportElement: JSX.Element;
    adjustmentModified?: boolean;
    sioeoImportModified?: boolean;
}

export interface ImportAdjustment {
    id: string,
    name: string,
}
export interface ImportAdjustmentsStructure {
    adjustments: ImportAdjustment[],
    adjustmentPermissions: ImportAdjustment[]
}

export interface ModifiedAdjustmentDict {
    [key: string]: boolean,
}

export interface ModifiedAdjustments {
    adjustments: ModifiedAdjustmentDict,
    adjustmentsPermissions: ModifiedAdjustmentDict,
}